import script from "./LotteryResultCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./LotteryResultCard.vue?vue&type=script&setup=true&lang=ts"

import "./LotteryResultCard.vue?vue&type=style&index=0&id=23ed428e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23ed428e"]])

export default __exports__